export default __webpack_public_path__ + "static/media/landingBackground2.59a72da3.png";